export default {
explore_by: "tutki mukaan",
explore_by_concepts: "ideat",
explore_by_families: "tuoksuperheet",
language: "kieli",
legal: "lakitiedot",
find_any_fragrance: "löydä mikä tahansa tuoksu maailmassa.",
title_by_concepts: "tutki ideoiden mukaan",
desc_by_concepts: "löydä tuoksusi ajattelemalla lempiväriäsi tai -paikkaasi",
title_by_families: "tutki tuoksuperheiden mukaan",
desc_by_families: "löydä tuoksusi ajattelemalla ...",
expert_reviewed: "asiantuntijoiden arvioima",
ingredients: "ainesosat",
description: "kuvaus",
perfumist: "parfyymimestari",
concepts: "konseptit",
olfactive_family: "tuoksuperhe",
main_family: "perhe",
sub_family: "alaperhe",
me_family: "Maailman tuoksut",
filter_by_family: "perheet",
filter_by_brand: "brändit",
filter_by_gender: "sukupuoli",
for_him: "hänelle",
for_her: "hänelle",
unisex: "unisex",
all: "kaikki",
all_female: "kaikki",
concepts_list: "konseptilista",
no_results_for_this_combination: "tälle yhdistelmälle ei ole hajuvesiä.",
select_at_least_one_concept: "valitse vähintään yksi konsepti",
view_perfumes: "näytä hajuvedet",
back: "takaisin",
close: "sulje",
filters: "suodattimet",
selected_concepts: "valitut konseptit:",
selected_families: "valitut perheet:",
find_concept: "etsi konsepteja...",
smell_of: "tuoksu",
touch_of: "ripauksella",
loading_perfumes: "ladataan hajuvesiä",
loading_concepts: "ladataan konsepteja",
apply: "käytä",
search: "etsi",
clear_all: "tyhjennä kaikki",
iconic_fragrances: "tämän perheen ikoniset tuoksut",
is_there_anybody_here: "oletko vielä täällä?",
continue_previous_session: "kyllä! jatketaan",
reset_session: "aloita kokemus uudelleen",
ingredient_type: "tyyppi",
ingredient_parts: "käytetyt osat",
ingredient_extraction: "uuttomenetelmä",
ingredient_first: "ikoninen hajuvesi",
history: "historia",
effect: "tuotanto ja vaikutus",
origin: "alkuperä",
iconic_fragrance: "ikoninen tuoksu",
production: "tuotanto",
loyalty_become_a_member: "Liity klubiin",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"  
}